<template>
  <div
    class="tarjeta-grafico"
    :style="tarjetaStyle"
  >
    
    <!-- Contenido para tarjetas de datos KPI -->
    <div class="data-content" type="button" @click="redireccionar">
      <div class="icono-superior">
        <b-icon :icon="icono" font-scale="1.8" :style="{ color: colorFont }"></b-icon>
      </div>
      <div class="content-body">
        <div class="dato-container">
          <h3 class="dato" :style="datoStyle">{{ formattedData.value }}</h3>
          <p class="unidad" :style="unidadStyle" v-if="formattedData.unit">{{ formattedData.unit }}</p>
        </div>
        <div class="titulo-container">
          <p class="titulo" :style="{ color: colorFont }">{{ titulo }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Tarjeta',
    props: ['color', 'icono', 'titulo', 'data', 'colorFont', 'url'],
    computed: {
        tarjetaStyle() {
            return {
                backgroundColor: this.color,
                width: '100%',
            };
        },
        formattedData() {
            return {
                value: String(this.data || 0),
                unit: null
            };
        },
        datoStyle() {
            const displayValue = this.formattedData.value;
            const length = displayValue.length;
            
            // Detectar diferentes tamaños de pantalla
            const screenWidth = window.innerWidth;
            const isSmall = screenWidth <= 576;  // xs
            const isMobile = screenWidth <= 768;  // sm
            const isTablet = screenWidth <= 992;  // md
            
            // Ajustar tamaño de fuente según longitud y tamaño de pantalla
            let fontSize;
            if (length > 15) {
                fontSize = isSmall ? '1.0rem' : isMobile ? '1.2rem' : isTablet ? '1.4rem' : '1.6rem';
            } else if (length > 10) {
                fontSize = isSmall ? '1.2rem' : isMobile ? '1.4rem' : isTablet ? '1.7rem' : '1.9rem';
            } else if (length > 6) {
                fontSize = isSmall ? '1.4rem' : isMobile ? '1.6rem' : isTablet ? '2.0rem' : '2.2rem';
            } else {
                fontSize = isSmall ? '1.6rem' : isMobile ? '1.8rem' : isTablet ? '2.2rem' : '2.4rem';
            }
            
            return {
                color: this.colorFont,
                fontSize: fontSize,
                fontWeight: '700',
                lineHeight: '1.1',
                margin: '0',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%'
            };
        },
        unidadStyle() {
            const isMobile = window.innerWidth <= 768;
            
            return {
                color: this.colorFont,
                fontSize: isMobile ? '0.8rem' : '0.9rem',
                fontWeight: '500',
                lineHeight: '1',
                margin: '2px 0 0 0',
                opacity: '0.8'
            };
        }
    },
    methods: {
        redireccionar() {
            if (this.url) {
                this.$router.push({name: 'GestionCBI', params: { filtroUnidad: this.url }});
            }
        }
    }
}
</script>

<style scoped>
    .tarjeta-grafico {
        position: relative;
        width: 100%;
        height: 120px;
        border-radius: 0;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        margin: 0 auto;
        transition: all 0.3s ease;
        color: #fff;
        overflow: hidden;
        border-left: 4px solid rgba(255,255,255,0.3);
        min-width: 0; /* Permite que la tarjeta se reduzca correctamente */
        display: flex;
        flex-direction: column;
    }
    
    .tarjeta-grafico:hover {
        box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        transform: translateY(-2px);
    }
    
    /* Contenido para tarjetas de datos KPI */
    .data-content {
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;
    }
    
    .icono-superior {
        position: absolute;
        top: 15px;
        right: 15px; /* Reducido para acercar más el icono al borde */
        opacity: 0.8;
        transition: opacity 0.3s ease;
        z-index: 10;
    }
    
    .tarjeta-grafico:hover .icono-superior {
        opacity: 1;
    }
    
    .content-body {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 15px 70px 15px 20px; /* Reducido el espacio derecho para dar más espacio al texto */
        min-width: 0; /* Permite que flex shrink funcione correctamente */
    }
    
    .dato-container {
        margin-bottom: 6px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-width: 0; /* Permite que flex shrink funcione correctamente */
        width: 100%;
    }
    
    .dato {
        margin: 0;
        text-align: left;
        text-shadow: 0 1px 2px rgba(0,0,0,0.1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%; /* Usar todo el ancho disponible */
        min-width: 0; /* Permite que el texto se corte correctamente */
    }
    
    .unidad {
        margin: 0;
        text-align: left;
        white-space: nowrap;
        max-width: calc(100% - 10px);
    }
    
    .titulo-container {
        flex: 1;
        display: flex;
        align-items: flex-start;
        width: 100%;
    }
    
    .titulo {
        margin: 0;
        text-align: left;
        font-size: 0.9rem;
        font-weight: 500;
        line-height: 1.2; /* Reducido para permitir más líneas */
        opacity: 0.9;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
        width: 100%; /* Ocupar todo el ancho disponible */
        flex: 1; /* Permitir que se expanda */
        white-space: normal; /* Permitir saltos de línea */
        overflow: visible; /* Mostrar texto completo */
    }
    

    
    /* Para pantallas extra pequeñas */
    @media (max-width: 576px) {
        .tarjeta-grafico {
            height: 90px;
        }
        
        .content-body {
            padding: 10px 55px 10px 12px; /* Reducido el espacio derecho */
        }
        
        .icono-superior {
            top: 10px;
            right: 12px;
            font-size: 1.4rem;
        }
        
        .dato-container {
            margin-bottom: 3px;
        }
        
        .titulo {
            font-size: 0.7rem;
            line-height: 1.1;
        }
    }
    
    /* Responsive para móviles */
    @media (max-width: 768px) and (min-width: 577px) {
        .tarjeta-grafico {
            height: 100px;
        }
        
        .content-body {
            padding: 12px 60px 12px 15px; /* Reducido el espacio derecho */
        }
        
        .icono-superior {
            top: 12px;
            right: 15px;
        }
        
        .dato-container {
            margin-bottom: 4px;
        }
        
        .titulo {
            font-size: 0.75rem;
            line-height: 1.2;
        }
    }
    
    /* Para tablets */
    @media (max-width: 992px) and (min-width: 769px) {
        .tarjeta-grafico {
            height: 110px;
        }
        
        .titulo {
            font-size: 0.85rem;
        }
    }
    
    /* Para pantallas medianas */
    @media (max-width: 1200px) and (min-width: 993px) {
        .titulo {
            font-size: 0.9rem;
        }
    }
</style>